<template>
  <el-config-provider :locale="locale">
    <router-view />
  </el-config-provider>
</template>
<script>
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

export default {
  name: 'appVIew',
  data() {
    return {
      isShow: false,
      locale: zhCn,
    }
  },
  mounted(){
   
  },
  methods: {
  
  }
}
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  border: 0;
  scroll-behavior: smooth; //平滑滚动
  font-size: 14px;
}

</style>
